import {
  WSElement,
  WSElementColorsType,
  WSText
} from "@wingspanhq/fe-component-library";
import React from "react";
import {
  RequirementDefinitionTemplate,
  RequirementDefinitionTemplateTier
} from "../../types";
import styles from "./index.module.scss";
const mapTierToColor: Record<
  RequirementDefinitionTemplateTier,
  WSElementColorsType
> = {
  Standard: "gray50",
  Smart: "blue50",
  SmartAdvanced: "violet50"
};

export const TemplateImage: React.FC<
  RequirementDefinitionTemplate & { disabled?: boolean }
> = props => {
  if (!props.image) {
    return null;
  }

  return (
    <WSElement
      className={styles.container}
      colorBackground={mapTierToColor[props.tier]}
    >
      <img src={props.image} />

      {props.disabled && (
        <WSElement className={styles.disabledOverlay}>
          <WSText color="white">Requirement already in use</WSText>
        </WSElement>
      )}
    </WSElement>
  );
};
